import { i18n } from "../../../plugins/i18n";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { StorageItemFileTypes } from "../enums/StorageItemFileTypes";

const MAX_FILE_SIZE = 3;

export default {
  name: "PlayerRegistrationPlayerDetailsBase",
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistration",
      "playerAvatar"
    ])
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, ["setPlayerAvatar"]),
    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "uploadPlayerAvatar",
      "uploadNewPlayerAvatar"
    ]),

    async handleUploadPlayerAvatar(e) {
      if (e !== null) {
        this.setPlayerAvatar({ name: "file", value: e?.target?.files?.[0] });
      }
      const uploadedFile = e ? e?.target?.files?.[0] : this.playerAvatar?.file;
      const fileSizeInMB = uploadedFile?.size / 1024 / 1024;
      this.setPlayerAvatar({
        name: "avatarUploadError",
        value: ""
      });

      if (fileSizeInMB > MAX_FILE_SIZE) {
        this.setPlayerAvatar({
          name: "avatarUploadError",
          value: i18n.tc("validation.max_file_size_is_3MB")
        });
      } else if (this.$route.params?.playerId) {
        this.setPlayerAvatar({
          name: "isFileUploading",
          value: true
        });
        return await this.uploadPlayerAvatar({
          playerId: this.$route.params.playerId,
          successCallback: () => {
            this.setPlayerAvatar({
              name: "imageUrl",
              value: URL.createObjectURL(uploadedFile)
            });
            this.setPlayerAvatar({
              name: "isFileUploading",
              value: false
            });
          }
        });
      } else {
        this.setPlayerAvatar({
          name: "isFileUploading",
          value: true
        });
        this.uploadNewPlayerAvatar({
          successCallback: () => {
            this.setPlayerAvatar({
              name: "imageUrl",
              value: URL.createObjectURL(uploadedFile)
            });
            this.setPlayerAvatar({
              name: "isFileUploading",
              value: false
            });
          }
        });
      }
    }
  }
};
